module.exports = __webpack_public_path__ + "soundwaves.gif?3987d13dea186cda5a2d20c6ca29d681";